import { CercTypes, OptInSubmitData, OptOutSubmitData, Pagamentos, UnidadeRecebivel } from './types'
export function cerqRequestOptIn(payload: OptInSubmitData) {
    return {
        type: CercTypes.SUBMIT_OPT_IN,
        payload
    }
}

export function cerqRequestOptOut(payload: OptOutSubmitData) {
    return {
        type: CercTypes.SUBMIT_OPT_OUT,
        payload
    }
}

///----------------
export function cercAddPayment(payload: Pagamentos) {
    return {
        type: CercTypes.ADD_PAYMENTS,
        payload
    }
}

export function cercAddUR(payload: UnidadeRecebivel) {
    return {
        type: CercTypes.ADD_UNIDADE_RECEBIVEL,
        payload
    }
}

export function cercRemovePayment(payload: number) {
    return {
        type: CercTypes.REMOVE_PAYMENTS,
        payload
    }
}

export function cercRemoveUR(payload: number) {
    return {
        type: CercTypes.REMOVE_UNIDADE_RECEBIVEL,
        payload
    }
}

export function cercDeleteAllPayments() {
    return {
        type: CercTypes.DELETE_ALL_PAYMENTS,
    }
}

export function cercDeleteAllURs() {
    return {
        type: CercTypes.DELETE_ALL_UNIDADE_RECEBIVEL,
    }
}

export function cercDeleteAllPaymentsOfUr(payload: number) {
    return {
        type: CercTypes.DELETE_ALL_PAYMENTS_OF_UR,
        payload
    }
}

// export function cerqSuccessOptIn(payload: boolean) {
//     return {
//         type: CerqTypes.SUCCESS_OPT_IN,
//         payload
//     }
// }

// export function cerqFailureOptIn() {
//     return {
//         type: CerqTypes.FAILURE_OPT_IN,
//     }
// }